import { Context } from 'react';
import { i18n } from 'design-system';

import { Languages, RealLanguages } from '../../languages';

const IntlContext = i18n.default as Context<IntlContextValue>;

export default IntlContext;

export type Language = i18n.Language;

export type IntlContextValue = i18n.IntlContextValue<Languages>;

export const getLanguageCode = () => i18n.getLanguageCode<RealLanguages>();

export const getLanguage = () => i18n.getLanguage();

export const setLanguage = (code: RealLanguages, language: Language) => i18n.setLanguage<RealLanguages>(code, language);
